import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-3xl md:text-4xl font-bold">Extracuriculars & Certifications</h2>
        </div>
        <div className="mt-6 ml-[10px] lgl:ml-[100px] lgl:mt-14 lgl:w-[1100px] w-[320px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="AWS Cloud Practioner"
            subTitle="Certification"
            result="In Progress"
            des="Helped me understand basic AWS cloud concepts, services, and the foundational best practices for AWS Cloud"
          />
          <ResumeCard
            title="Public Relations"
            subTitle="Extracuricular Certificate"
            result="Success"
            des="I learned about Public Realations through hands-on experience at college fests."
          />
          <ResumeCard
            title="Even Coordinator"
            subTitle="Extracuricular Certificate"
            result="Success"
            des="I learned about how to host, manage and complete a succeful event through hands-on experience at college fests."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
